import * as React from 'react';
export function useNavCategoryItemContextValues_unstable(state) {
    const { open, value } = state;
    const navCategoryItem = React.useMemo(()=>({
            open,
            value
        }), [
        open,
        value
    ]);
    return {
        navCategoryItem
    };
}
